<template>
  <section class="bg-h-primary-50 py-10">
    <div class="container mx-auto">
      <GridLayout :list="list" :banner="banner" @onScroll="scrollMeTo">
        <template #content>
          <div :ref="enumLinks.general">
            <General @onGetCurrentObjective="getCurrentObjective" />
          </div>
          <div :ref="enumLinks.questions">
            <Objects />
          </div>
          <div :ref="enumLinks.questions">
            <Questions />
          </div>
          <div :ref="enumLinks.feedbacks">
            <Feedbacks />
          </div>
          <div :ref="enumLinks.draftsFeedbacks">
            <DraftsFeedbacks :currentObjective="currentObjective" />
          </div>
        </template>
      </GridLayout>
    </div>
  </section>
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent } from "vue";

const GridLayout = defineAsyncComponent(() => import("../Grid/grid.vue"));

const General = defineAsyncComponent(
  () => import("../Objective/General/general.vue")
);

const DraftsFeedbacks = defineAsyncComponent(
  () => import("../Objective/DraftsFeedbacks/drafts-feedbacks.vue")
);
const Questions = defineAsyncComponent(
  () => import("../Objective/Questions/questions.vue")
);
const Objects = defineAsyncComponent(
  () => import("../Objective/Objects/objects.vue")
);

const Feedbacks = defineAsyncComponent(
  () => import("../Objective/Feedbacks/feedbacks.vue")
);

enum Links {
  general = "general",
  draftsFeedbacks = "draftsFeedbacks",
  questions = "questions",
  objects = "objects",
  feedbacks = "feedbacks",
}

export default defineComponent({
  name: "objectiveStats",
  components: {
    GridLayout,
    General,
    DraftsFeedbacks,
    Questions,
    Objects,
    Feedbacks,
  },
  computed: {
    enumLinks(): typeof Links {
      return Links;
    },
  },
  data() {
    return {
      list: {
        title: (this.$route.params.objectiveName as any)?.replaceAll("-", " "),
        links: [
          {
            name: this.$t("stats.objectives.sidebar.general"),
            linkId: Links.general,
          },
          {
            name: this.$t("stats.objectives.sidebar.objects"),
            linkId: Links.objects,
          },
          {
            name: this.$t("stats.objectives.sidebar.questions"),
            linkId: Links.questions,
          },
          {
            name: this.$t("stats.objectives.sidebar.feedbacks"),
            linkId: Links.feedbacks,
          },
          {
            name: this.$t("stats.objectives.sidebar.draftsFeedbacks"),
            linkId: Links.draftsFeedbacks,
          },
        ],
      },
      banner: {
        icon: require("@/assets/images/stats/objective-icon.svg"),
        background: require("@/assets/images/stats/objective.svg"),
        title: "Objetivo",
      },
      currentObjective: {} as any,
    };
  },
  methods: {
    scrollMeTo(refName: any): void {
      var element: HTMLElement | any = this.$refs[refName];
      var top = element?.offsetTop;
      if (refName === Links.general) {
        window.scrollTo(0, 0);
      } else {
        window.scrollTo(0, top);
      }
    },
    getCurrentObjective(currentObjective: any): void {
      this.currentObjective = currentObjective;
    },
  },
});
</script>
